import { useViewport } from '@tryhackme/thm-ui-components';

import { BREAKPOINTS } from 'src/common/constants/breakpoints';
import { RoomUserEventType } from 'src/common/enums/rooms';
import { useGetUserQuery } from 'src/common/slices';
import { useRoomCode } from './hooks/use-room-replacement-experiment';
import { useGetRoomDetailQuery } from './room.slice';
import type { RoomUserEvent, RoomUserTicketEvent } from './room.types';

export const useUserEchoEnabled = () => {
  const { data: userData } = useGetUserQuery();
  return userData?.data?.user?.tutorEnabled ?? true;
};

export const useIsEchoEnabledInCurrentRoom = () => {
  const { width, height } = useViewport();
  const echoEnabled = useUserEchoEnabled();

  const roomCode = useRoomCode();
  const { data: roomData } = useGetRoomDetailQuery(roomCode ?? '', { skip: !roomCode });

  const room = roomData?.data;
  if (!room || !echoEnabled) {
    return false;
  }

  const isTutorVisible = room.tutor?.isVisible;
  const isJoined = room.joined;

  const isSmallScreen = width < BREAKPOINTS.MOBILE || height < 600;

  return isJoined && isTutorVisible && !isSmallScreen;
};

export const useIsAskEchoEnabledInCurrentRoom = () => {
  const roomCode = useRoomCode();
  const { data: roomData } = useGetRoomDetailQuery(roomCode ?? '', { skip: !roomCode });

  if (!roomCode) return false;

  const room = roomData?.data;
  const isAskEchoEnabled = room?.isAskEchoEnabled;

  return Boolean(isAskEchoEnabled);
};

export const isRoomUserTicketEvent = (data: RoomUserEvent): data is RoomUserTicketEvent =>
  data.type === RoomUserEventType.TICKETS_AWARDED && 'tickets' in data;
